export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.684 13.324a.952.952 0 11-1.463-1.22l3.328-3.993H1.18c-.467 0-.846-.415-.846-.926 0-.511.379-.926.846-.926h9.677L7.221 1.895A.953.953 0 018.684.676l4.762 5.714a.952.952 0 010 1.22l-4.762 5.714z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "14",
    "height": "14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};